

export const DRAMA_ERROR_CODES = {

  D001: { code: 'D001', message: '请求格式错误' },
  D002: { code: 'D002', message: '请求参数无效' },
  D003: { code: 'D003', message: '请求格式错误' },
  D004: { code: 'D004', message: '资源不存在' },
  D005: { code: 'D005', message: '服务繁忙，请稍后重试' },
  D006: { code: 'D006', message: '无权操作' },
  D007: { code: 'D007', message: '用户信息有误' },
  D008: { code: 'D008', message: '类型不对' },
  D009: { code: 'D009', message: '参数不对' },

  D010: { code: 'D010', message: '请先登录' },
  D011: { code: 'D011', message: '登录已失效' },
  D012: { code: 'D012', message: '剧本信息有误' },
  D013: { code: 'D013', message: '没有访问权限' },
  D014: { code: 'D014', message: '权限不足' },

  D015: { code: 'D015', message: '你不是团队成员' },
  D016: { code: 'D016', message: '权限不足' },
  D017: { code: 'D017', message: '不是目标团队所有者' },
  D018: { code: 'D018', message: '团队查询失败' },
  D019: { code: 'D019', message: '已在目标团队' },

  D020: { code: 'D020', message: '剧本解析中…' },
  D021: { code: 'D021', message: '解析启动失败' },
  D022: { code: 'D022', message: '自动制作失败' },
  D023: { code: 'D023', message: '重置失败' },
  D024: { code: 'D024', message: '剧情解析中…' },
  D025: { code: 'D025', message: '抽取角色失败' },
  D026: { code: 'D026', message: '部分集拆解失败,可单独重试这些集' },
  D027: { code: 'D027', message: '拆集失败,可能是模型超时,请稍后重试' },
  D029: { code: 'D029', message: '抽取场景失败' },

  D040: { code: 'D040', message: '生成失败' },
  D041: { code: 'D041', message: '生成失败' },
  D042: { code: 'D042', message: '请填写名称' },
  D043: { code: 'D043', message: '请填写内容' },
  D044: { code: 'D044', message: '内置模板不可改' },
  D045: { code: 'D045', message: '模板不存在' },
  D046: { code: 'D046', message: '无权操作模板' },
  D047: { code: 'D047', message: '模板不存在' },
  D048: { code: 'D048', message: '分类无效' },
  D049: { code: 'D049', message: '请选择模板' },

  D050: { code: 'D050', message: '模型不存在' },
  D051: { code: 'D051', message: 'ID 已存在' },
  D052: { code: 'D052', message: '所选服务已禁用' },
  D053: { code: 'D053', message: '模型配置错误' },
  D054: { code: 'D054', message: '模型暂不可用' },
  D055: { code: 'D055', message: '类型不支持' },
  D058: { code: 'D058', message: '暂无可用模型' },

  D060: { code: 'D060', message: '场景生成失败' },
  D061: { code: 'D061', message: '场景不存在' },
  D062: { code: 'D062', message: '场景主图失败' },
  D063: { code: 'D063', message: '批量生成失败' },
  D064: { code: 'D064', message: '请先生成场景主图' },
  D065: { code: 'D065', message: '画板未就绪' },
  D066: { code: 'D066', message: '画板类型无效' },
  D067: { code: 'D067', message: '视图无效' },
  D068: { code: 'D068', message: '裁剪失败' },
  D069: { code: 'D069', message: '补充视图失败' },
  D070: { code: 'D070', message: '保存失败' },
  D071: { code: 'D071', message: '渲染失败' },
  D072: { code: 'D072', message: '全景功能未开启' },
  D073: { code: 'D073', message: '全景生成失败' },
  D074: { code: 'D074', message: '全景生成中…' },
  D075: { code: 'D075', message: '文件打开失败' },
  D076: { code: 'D076', message: '文件读取失败' },

  D080: { code: 'D080', message: '批量任务失败' },
  D081: { code: 'D081', message: '链接生成失败' },
  D082: { code: 'D082', message: '导出失败' },
  D083: { code: 'D083', message: '该集不存在' },
  D084: { code: 'D084', message: '分镜生成失败' },
  D085: { code: 'D085', message: '分镜不存在' },
  D086: { code: 'D086', message: '分镜未就绪' },
  D087: { code: 'D087', message: '镜头不存在' },
  D088: { code: 'D088', message: '请先生成场景' },
  D089: { code: 'D089', message: '接续图无效' },
  D090: { code: 'D090', message: '接续图未就绪' },
  D091: { code: 'D091', message: '关键帧失败' },
  D092: { code: 'D092', message: '请先生成首帧' },
  D093: { code: 'D093', message: '提示词生成失败' },
  D094: { code: 'D094', message: '处理中，无法删除' },
  D095: { code: 'D095', message: '提示词不存在' },
  D096: { code: 'D096', message: '处理中，无法删除' },
  D097: { code: 'D097', message: '未完成，无法主选' },
  D098: { code: 'D098', message: '操作失败' },

  D100: { code: 'D100', message: '版本号无效' },
  D101: { code: 'D101', message: '版本不存在' },
  D102: { code: 'D102', message: '回滚失败' },
  D103: { code: 'D103', message: '邮箱格式错误' },
  D104: { code: 'D104', message: '不能邀请自己' },
  D105: { code: 'D105', message: '角色无效' },
  D106: { code: 'D106', message: '对方已是所有者' },
  D107: { code: 'D107', message: '邀请失败' },
  D108: { code: 'D108', message: '不能对自己操作' },
  D109: { code: 'D109', message: '更新失败' },
  D110: { code: 'D110', message: '移除失败' },
  D111: { code: 'D111', message: '邀请已失效' },
  D112: { code: 'D112', message: '转让失败' },
  D113: { code: 'D113', message: '目标用户无效' },
  D114: { code: 'D114', message: '接受邀请失败' },

  D120: { code: 'D120', message: '上传服务未开启' },
  D121: { code: 'D121', message: '链接无效' },
  D122: { code: 'D122', message: '最多 200 条' },
  D123: { code: 'D123', message: '任务不存在' },
  D124: { code: 'D124', message: '文件超过 50MB' },
  D125: { code: 'D125', message: '空间已满' },

  D126: { code: 'D126', message: '无访问权限' },
  D127: { code: 'D127', message: '请先选择团队' },

  D130: { code: 'D130', message: '模型不存在' },
  D131: { code: 'D131', message: '模型已禁用' },
  D132: { code: 'D132', message: '不是图像模型' },
  D133: { code: 'D133', message: '请填写提示词' },
  D134: { code: 'D134', message: '任务不存在' },

  D135: { code: 'D135', message: '请选择视频模型' },
  D136: { code: 'D136', message: '模型不存在' },
  D137: { code: 'D137', message: '模型已禁用' },
  D138: { code: 'D138', message: '不是视频模型' },
  D139: { code: 'D139', message: '任务不存在' },

  D160: { code: 'D160', message: '作品已删除' },
  D161: { code: 'D161', message: '无权修改' },
  D162: { code: 'D162', message: '尚未公开' },
  D163: { code: 'D163', message: '请先同意分享条款' },
  D164: { code: 'D164', message: '请补全标题、简介、分类' },
  D165: { code: 'D165', message: '剧本尚未就绪' },
  D166: { code: 'D166', message: '请用「更新版本」' },
  D167: { code: 'D167', message: '当前状态不允许' },
  D168: { code: 'D168', message: '翻页失败，请刷新' },

  D190: { code: 'D190', message: '请刷新画布' },

  D200: { code: 'D200', message: 'AI 助手忙，请稍后' },
  D201: { code: 'D201', message: '会话已失效' },
  D202: { code: 'D202', message: '作品不属于你' },
} as const;

export type DramaErrorCode = keyof typeof DRAMA_ERROR_CODES;

export function isDramaErrorCode(code: string | undefined | null): boolean {
  if (!code) return false;
  return /^D\d{3}$/.test(code);
}

export function getDramaErrorMessage(code: string): string {
  const entry = DRAMA_ERROR_CODES[code as DramaErrorCode];
  return entry?.message || '';
}
